import styled from "styled-components";
import DELETE_SVG from "../../images/delete.svg";
import LoadingWithProgressBar from "../common/LoadingWithProgressBar";
import Modal from "../common/Modal";
import DragAndDrop from "./DragAndDrop";
import useInquiry from "../../hooks/inquiry/useInquiry";

function Form(){
    const {fileList, handleChange, inputs, onChange, onSubmitClick, targetFileName, progress, showLoading, showSucceedModal, onSucceedModalConfirmHandler} = useInquiry();
    const getFileList = () => {
        return fileList.map((item, index) => {
            return <Item key={index}><FileName>{item.name}</FileName><ButtonDelete src={DELETE_SVG} alt="delete"/></Item>
        })
    }

    return(
        <Container>
            <Modal isOpen={showSucceedModal} title={"SUCCESS"} content={"문의 등록에 성공하였습니다"} onClose={onSucceedModalConfirmHandler}/>
            {showLoading ? <LoadingWithProgressBar title={"파일 업로드"} subTitle={targetFileName} progress={progress}/> : null}
            <InputHeaderWrap>
                <CheckSecretWrap><CheckBox type="checkbox" name="isSecret" onChange={onChange}/><Label>비밀글</Label></CheckSecretWrap>
                {inputs.isSecret ? <Input type="password" name="password" placeholder="비밀번호" onChange={onChange} value={inputs.password}/> : null}
                <Select name="category" onChange={onChange} defaultValue={inputs.category}>
                    <Option value={"기타"}>기타</Option>
                    <Option value={"계정"}>계정</Option>
                    <Option value={"결제"}>결제</Option>
                    <Option value={"주문/배송"}>주문/배송</Option>
                </Select>
            </InputHeaderWrap>
            <InputWrap>
                <Label htmlFor="content">내용</Label>
                <TextArea id="content" placeholder="문의 내용" name="content" onChange={onChange} value={inputs.content}></TextArea>
            </InputWrap>
            <DragAndDrop handleChange={handleChange}/>
            <ItemWrap>
                {getFileList()}
            </ItemWrap>
            <ButtonSubmit onClick={onSubmitClick}>작성 하기</ButtonSubmit>
        </Container>
    )
}

const Container = styled.div`
    margin-top: 60px;
    padding: 24px;
    max-width: 600px;
    width: 100%;
    gap: 18px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`

const InputHeaderWrap = styled.div`
    display: flex;
    gap: 18px;
    width: 100%;
    ::placeholder{
        color:#999;
    }
`

const CheckSecretWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
`

const InputWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

const CheckBox = styled.input`
    width: 18px;
    height: 18px;
`

const Input = styled.input`
    padding: 12px;
    border-radius: 20px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #C7CCD2;
    ::placeholder{
        color:#999;
    }
`

const Select = styled.select`
    padding: 12px;
    border-radius: 20px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #C7CCD2;
    ::placeholder{
        color:#999;
    }
`

const Option = styled.option`
`

const Label = styled.label`
    color: #222;
    font-size: 14px;
`

const TextArea = styled.textarea`
    padding: 12px;
    border: 1px solid #C7CCD2;
    background: #FFF;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    height: 180px;
    border-radius: 20px;
    resize: vertical;
    ::placeholder{
        color:#999;
    }
`

const Item = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px dashed #4A1B65;
`

const ItemWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

const ButtonDelete = styled.img`
    width: 10px;
    height: 10px;
    cursor: pointer;
`

const FileName = styled.span`
    color: #999;
    font-size: 12px;
    font-weight: 400;
`

const ButtonSubmit = styled.button`
    margin-top: 40px;
    color: #FFF;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    border-radius: 30px;
    background-color: #007912;
    border: none;
    padding: 12px;
    cursor: pointer;
`


export default Form;